
import { ONBOARDING_TOKEN_LABEL } from "../../lib/token";

const prefix = "http://127.0.0.1:" + (process.env.PORT || 3000);

const redirect_on_error = (req, orig_callback) => (err, res) => {

  if (err && err.status === 401) {
    console.log("Unauthorized. Redirect to",
      "/login?redirect=" +
      window.location.pathname +
      window.location.search);
    // Unauthorized API request
    // Redirect to login with hard refresh
    // Do not use route redirect
    // We need to clear all app states for security reasons
    window.location =
      "/login?redirect=" +
      window.location.pathname +
      window.location.search;
  } else if (err && err.status === 403) {
    // not allowed to access this resource
    // use dispatch to update state and then show on UI
  }
  orig_callback.call(req, err, res);
};

const authorize = token => {

  return req => {

    // I'm guessing this is a client vs server build.
    if (process.env.BUILD_TARGET === "client") {

      req.callback = redirect_on_error(req, req.callback);

    } else {
      if (req.url[0] === "/") {
        req.url = prefix + req.url;
      }
    }

    req.set('Accept', 'application/json');

    if (typeof(token) === 'string') {
      req.set({ "token": token });
    } else if (typeof(token) === 'object') {
      // We passed in a state object. Get the token.
      req.set({ "token": token.user.token});
    } else {
      console.log("Token of unknown type " + typeof(token));
    }
    return req;
  }
};

/**
 * @param token {string} Login token
 * @param onboarding_token {string} Onboarding token
 *
 * If the onboarding token exists, put it in the header, else put the
 * login token in the header.
 */
const authorize_onboarding = (token, onboarding_token) => {

  return req => {

    // I'm guessing this is a client vs server build.
    if (process.env.BUILD_TARGET === "client") {

      req.callback = redirect_on_error(req, req.callback);

    } else {
      if (req.url[0] === "/") {
        req.url = prefix + req.url;
      }
    }

    req.set('Accept', 'application/json');

    if (onboarding_token) {
      req.set({ [ONBOARDING_TOKEN_LABEL]: onboarding_token })
    } else if (token) {
      req.set({ "token": token });
    }

    return req;
  }
};


export { authorize, authorize_onboarding };
